export enum CompanyStatuses {
  LOADING = "LOADING",
}
